module.exports = __webpack_public_path__ + "static/img/point-icon-img@w.139743e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/serveone/point-icon-img@w.png
// module id = S3bL
// module chunks = 0